<template>
  <div
    class="root"
    @click="toggle"
  >
    <slot name="default" />
    <div
      v-if="show"
      class="form-container"
    >
      <div
        class="form"
        @click.stop
      >
        <div class="header">
          <p>
            <slot name="header" />
          </p>
          <v-icon
            size="24"
            @click="toggle"
          >
            {{ icons.mdiClose }}
          </v-icon>
        </div>
        <div class="content">
          <slot
            name="content"
            :closeFn="toggle"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .root {
    display: inline;
  }

  .form-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 4;
  }

  .form {
    position: absolute;
    top: 0;
    right: 0;
    width: 480px;
    height: 100vh;
    background-color: #fff;
    text-align: initial;
    -webkit-box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.4);
    box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.4);
  }

  .header {
    position: relative;
    background-color: #F9F8F9;
    padding: 1.4rem;
  }

  .header p {
    display: inline;
    font-size: 1rem;
    font-weight: bold;
    color: #70697A;
  }

  .header .v-icon {
    position: absolute;
    cursor: pointer;
    right: 32px;
  }

  .content {
    padding: 1.4rem;
    padding-right: 2.4rem;
    max-height: 94vh;
    overflow-y: auto;
  }
</style>

<script>
import { mdiClose } from '@mdi/js';

export default {
  data() {
    return {
      show: false,
      icons: {
        mdiClose,
      },
    };
  },

  methods: {
    toggle(event) {
      if (event) {
        event.stopPropagation();
      }

      this.show = !this.show;
    },
  },
};
</script>
